// Compone el texto de un tiquete de venta (40 columnas, típico de térmica 80mm).
import { money } from "../utils";

const W = 40;

function line(left: string, right: string): string {
  const space = Math.max(1, W - left.length - right.length);
  return left + " ".repeat(space) + right;
}
function center(s: string): string {
  const pad = Math.max(0, Math.floor((W - s.length) / 2));
  return " ".repeat(pad) + s;
}
const sep = "-".repeat(W);

export interface ReceiptData {
  org: string;
  branch: string;
  items: { name: string; qty: number; unitPrice: number }[];
  total: number;
  paid: number;
  change: number;
  method: string;
  cufe?: string;
  authCode?: string;
}

export function composeReceipt(d: ReceiptData): string {
  const out: string[] = [];
  out.push(center(d.org));
  out.push(center(d.branch));
  out.push(center(new Date().toLocaleString("es-PA")));
  out.push(sep);
  for (const it of d.items) {
    out.push(it.name.slice(0, W));
    out.push(line(`  ${it.qty} x ${money(it.unitPrice)}`, money(it.qty * it.unitPrice)));
  }
  out.push(sep);
  out.push(line("TOTAL", money(d.total)));
  out.push(line(`Pago (${d.method})`, money(d.paid)));
  if (d.change > 0) out.push(line("Vuelto", money(d.change)));
  if (d.cufe) {
    out.push(sep);
    out.push("CUFE:");
    out.push(d.cufe);
    if (d.authCode) out.push(`Autorización: ${d.authCode}`);
  }
  out.push(sep);
  out.push(center("¡Gracias por su compra!"));
  return out.join("\n");
}
